/**
 * データ種別リスト
 */
export enum simpleSearchDataTypeList {
  travosRealTime5Minute,
  travosRealTime1Hour,
  etcDrmDay,
  etcDrmMonth,
}

/**
 * 平休リスト
 */
export enum dayTypeList {
  weekday,
  holiday,
  allDay,
}
